export default {
  Independent: 'blue.100',
  'Sponsor Affiliated': 'purple.100',
}
